import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { Building2, Shield, Globe, Wand2, Calculator } from "lucide-react";
import * as tests from "./testDefinitions";

export const FoundationSection = ({ testResults }) => {
  return (
    <Card className="shadow-none border border-blue-200 bg-blue-50/20">
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Foundation</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Building2}
          iconColor="text-blue-600"
          title="Organization Lifecycle"
          tests={tests.orgLifecycleTests}
          results={testResults.orgLifecycle}
        />
        
        <TestSubsection
          icon={Shield}
          iconColor="text-indigo-600"
          title="Multi-Tenant Isolation"
          tests={tests.multiTenantTests}
          results={testResults.multiTenant}
        />
        
        <TestSubsection
          icon={Globe}
          iconColor="text-green-600"
          title="Country/Region Config"
          tests={tests.countryConfigTests}
          results={testResults.countryConfig}
        />
        
        <TestSubsection
          icon={Wand2}
          iconColor="text-purple-600"
          title="Service Wizard"
          tests={tests.serviceWizardTests}
          results={testResults.serviceWizard}
        />
        
        <TestSubsection
          icon={Calculator}
          iconColor="text-orange-600"
          title="Booking Availability & Pricing"
          tests={tests.bookingAvailabilityTests}
          results={testResults.bookingAvailability}
        />
      </CardContent>
    </Card>
  );
};
